import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import { PresenterSettings as PresenterSettingsComponent } from '@shoflo/polymer/components/PresenterSettings/PresenterSettings';
import { AgoraAttendeeTile } from '@shoflo/polymer/components/Tile/AgoraAttendeeTile';
import updatePresenterSettings from 'actions/presenter/updatePresenterSettings';
import useModal from 'hooks/useModal';
import { CAMERA_PRESENTER } from '@studio/constants/Sources';
import { GENERIC_PRESENTER_SETTINGS } from '@studio/constants/ModalTypes';

function GenericPresenterSettings() {
  const dispatch = useDispatch();
  const meetingSession = useSelector(state => state.meeting.meetingSession);
  const attendeeTiles = useSelector(state => state.meeting.attendeeTiles);
  const presenterSettingsSource = useSelector(
    state => state.presenterSettingsSource
  );

  const { isOpen, clear } = useModal(GENERIC_PRESENTER_SETTINGS);

  function handleFormSave(payload) {
    dispatch(updatePresenterSettings(presenterSettingsSource, payload));
    clear();
  }

  const maxWidthMap = {
    [CAMERA_PRESENTER]: '436px',
    default: '572px'
  };

  const style = {
    maxWidth: maxWidthMap[presenterSettingsSource.type] || maxWidthMap.default
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={clear} autoFocus style={style}>
      <PresenterSettingsComponent
        source={presenterSettingsSource}
        meetingSession={meetingSession}
        attendeeTiles={attendeeTiles}
        onSubmit={handleFormSave}
        onCancel={clear}
        AttendeeTileComponent={AgoraAttendeeTile}
      />
    </Modal>
  );
}

export default GenericPresenterSettings;
